export default (study, extraData) => {
  const ret = extraData?.displaySets?.filter(ds => ds.numImageFrames > 0)?.length;
  if (process.env.NODE_ENV !== 'production') {
    console.log('number of display sets with images', ret);
  }
  return ret;
};
